export class SocialNetworkStatiscs {
  public followers: number;
  public following: number;
}
